import { useSyncExternalStore } from 'react';
import { useUserStore } from '../stores/useUserStore';

export type WebAccountSession = { userId: number | null; generation: number };

let current: WebAccountSession = {
  userId: useUserStore.getState().user?.id ?? null,
  generation: 0,
};
const listeners = new Set<() => void>();

useUserStore.subscribe((state) => {
  const userId = state.user?.id ?? null;
  if (userId === current.userId) return;
  current = { userId, generation: current.generation + 1 };
  listeners.forEach((listener) => listener());
});

export function currentWebAccountSession(): WebAccountSession {
  return current;
}

export function isCurrentWebAccountSession(session: WebAccountSession): boolean {
  return session.userId === current.userId && session.generation === current.generation;
}

export function useWebAccountSession(): WebAccountSession {
  return useSyncExternalStore(
    (listener) => {
      listeners.add(listener);
      return () => { listeners.delete(listener); };
    },
    currentWebAccountSession,
  );
}
